module.exports = __webpack_public_path__ + "img/theme4.7ba0c092.png";